/* ----------------------------------------------------------------------
 * Valida Form de inscrição.
 * ----------------------------------------------------------------------
 */

// JMask Global Options
$.jMaskGlobals = {
    maskElements: 'input',
    dataMaskAttr: '*[data-mask]',
    dataMask: true,
    watchInterval: 300,
    watchInputs: true,
    watchDataMask: false,
    byPassKeys: [9, 16, 17, 18, 36, 37, 38, 39, 40, 91],
    translation: {
        '0': {pattern: /\d/},
        '9': {pattern: /\d/, optional: true},
        '#': {pattern: /\d/, recursive: true},
        'A': {pattern: /[a-zA-Z0-9]/},
        'S': {pattern: /[a-zA-Z]/}
    }
};

var obr = ['local_prova_id']; // default
var ultima_etapa_validada = false;
var ultima_etapa = 0;
var controll_tab = 0; // tab inicial
var AJAX_CURSOS_CARREGADOS = false;


function inscricaoAjaxCursos() {
    ajaxCursos();
}

$(document).ready(function () {

    var VESTIBULAR_QUIZ = false;

    moment.locale('pt-BR');

    // Formata Campos
    $('#fone_contato').mask('(00) 0000-00009');
    $('.cpf').mask("000.000.000-00", {reverse: true, clearIfNotMatch: true})
        .prop('placeholder', '___.___.___-__');
    $('.cep').mask("00000-000").prop('placeholder', '_____-___');
    $('.data').mask("00/00/0000").prop('placeholder', '__/__/____');
    $("#tab4 #numero").mask("09999999").prop('placeholder', '________');

    var blocoFormaEnsino = $("#bloco_forma_ensino");
    var divTabVestibular = $("#divTabVestibular");
    var blockEscola = $("#blockEscola");
    var inputCheckListaCidades = blockEscola.find("#check_lista_cidades");

    setarBotoesFormaEnsino();
    formatarEtapa4();
    formatarBlocoConsultor();

    if($.urlParam('forma_ensino') == 'ead'){

        $('.nav-tabs a[href="#ensino_ead"]').tab('show');
    }else{

        $('.nav-tabs a[href="#ensino_presencial"]').tab('show');
    }

    // Monta o datepicker para campos de data
    $('.input-group.date').datepicker({
        language: 'pt-BR',
        format: "dd/mm/yyyy",
        autoclose: true,
        todayBtn: true,
        todayHighlight: "linked"
    });

    // monta o iCheck para todos os radiobuttons das etapas de inscricao
    $('.radio .radio-inline input').iCheck({
        checkboxClass: 'icheckbox_square-blue',
        radioClass: 'iradio_square-blue',
        increaseArea: '20%'
    });

    // monta o iCheck para os radiobuttons da 1a etapa de identificacao do candidato
    $('.unidades-estudar.radio .radio-inline input').iCheck({
        checkboxClass: 'icheckbox_square-blue',
        radioClass: 'iradio_square-blue',
        increaseArea: '20%'
    }).on('ifChecked', function(){
        var id_filial_selected = $(this).val();

        //Desmarca todos os vestibulares selecionados
        var input_vestibular = $("input[name=vestibular_id]").iCheck('uncheck');
        $('#group_vestibular .table tbody tr').removeClass('marcar-linha');

        // a variavel lista_processos eh global e esta sendo declarada no arquivo index da primeira etapa
        $.each(lista_processos, function(i, processo) {
            var encontrou = false;
            $.each(processo.filiais, function(j, filial){
                if (id_filial_selected == filial.id && !processo.isEad) {
                    encontrou = true;
                }
            });
            if (encontrou) {
                divTabVestibular.find(".vestibular_id_" + processo.id).show();
            } else {
                divTabVestibular.find(".vestibular_id_" + processo.id).hide();
            }
        });
    });

    $('.polos-estudar.radio .radio-inline input').iCheck({
        checkboxClass: 'icheckbox_square-blue',
        radioClass: 'iradio_square-blue',
        increaseArea: '20%'
    }).on('ifChecked', function(){
        var id_polo_selected = $(this).val();
        //Desmarca todos os vestibulares selecionados
        $("input[name=vestibular_id]").iCheck('uncheck');
        $('#group_vestibular .table tbody tr').removeClass('marcar-linha');

        // Quando marcado um polo, seleciona a filial 1 (caxias)
        $('.unidades-estudar.radio .radio-inline input[value=1]').iCheck('check');

        // Filtrar para exibir apenas os vestibulares daquele polo.
        var id_filial_selected = 1;

        // a variavel lista_processos eh global e esta sendo declarada no arquivo index da primeira etapa
        $.each(lista_processos, function(i, processo) {
            var encontrou = false;
            if (processo.isEad) {
                $.each(processo.polos, function(j, polo){
                    if (id_polo_selected == polo.polo_id) {
                        encontrou = true;
                    }
                });
            }
            if (encontrou) {
                divTabVestibular.find(".vestibular_id_" + processo.id).show();
            } else {
                divTabVestibular.find(".vestibular_id_" + processo.id).hide();
            }
        });
    });

    // Monta os radio buttons da etapa 2 FORMA DE INGRESSO
    $('#group_vestibular input[name=vestibular_id], #tab_locais_prova input[name=local_prova_id], #group_necessidades input[name=necessidades_especiais\\[\\]]').iCheck({
        checkboxClass: 'icheckbox_square-blue',
        radioClass: 'iradio_square-blue',
        increaseArea: '20%'
    });

    var tab_vestibular = $('#group_vestibular .table');
    /*tab_vestibular.find('input[name=vestibular_id]').on('ifChanged', function(){
        tab_vestibular.find('tbody tr').removeClass('marcar-linha');
        tab_vestibular.find('tbody tr.vestibular_id_' + this.value).addClass('marcar-linha');
    });*/

    // Monta os clicks nos nomes dos Vestibulares para ativar os iCheck
    $("#group_vestibular .link-check").on('click', function(){
        tab_vestibular.find('tbody tr.vestibular_id_' + $(this).attr('vestibular_id') + ' input[name=vestibular_id]').iCheck('check');
    });

    // Atrela os eventos do form conforme seleção das opções
    var inputs_vestibular_id = $('input[name=vestibular_id]').on('ifChanged', function(event) {
        tab_vestibular.find('tbody tr').removeClass('marcar-linha');
        tab_vestibular.find('tbody tr.vestibular_id_' + this.value).addClass('marcar-linha');

        var obj = $(this).filter(':checked');

        validarUtilizarNotaEnem(obj);
        buscarLocaisProva(obj);
        buscarVestibularcontinuadoDatas(obj, 'P');
        inscricaoAjaxCursos();

        if (obj.attr('isead')) {
            $("#mensagemCursoGratisEad").removeClass('hide');
        } else {
            $("#mensagemCursoGratisEad").addClass('hide');
        }

    }).change();
    //buscarLocaisProva();

    // Sempre que filtrar os cursos
    $('#filtro_curso input').iCheck({
        checkboxClass: 'icheckbox_square-blue',
        radioClass: 'iradio_square-blue',
        increaseArea: '20%'
    }).on('ifChanged', function(){
        filter_curso();
    });


    // Sempre que escolher uma nova unidade recarrega os cursos
    $('input[name=filial_id]').on('ifChanged', function() {
        AJAX_CURSOS_CARREGADOS = false;
        // Se for selecionado uma filial diferente de Caxias e um curso EAD estiver Selecionado, desmarca-o
        if((!$('input[name=filial_id][value=1]:checked').length > 0)
            && ($('input[name=vestibular_id][isead=1]:checked').length > 0)) {
            //$('input[name=vestibular_id]').prop('checked', false);
            $('input[name=vestibular_id]').iCheck('uncheck')
                .parents('tr').removeClass('marcar-linha');
        }

        // Buscar cursos
        inscricaoAjaxCursos();
    });

    // Sempre que ativa uma tab, controla navegação das etapas
    $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {

        var x = activeTab();
        var posicao = 0;
        var a = $('#tab-etapas li a');

        $.each(a, function (key, el) {
            if(el.getAttribute('aria-controls') == x) {
                posicao = key;
            }
        });
        controll_tab = posicao;
        controll_button_back();
        libera_tab(x);
    });

    // controla o botão de voltar
    button_back();

    /* Remove a possibilidade de avançar etpas não validadas */
    $('li.disabled a').removeAttr('data-toggle');

    /* Forma de ingresso */

    var forma_ingresso;

    $('input[name=forma_ingresso]').on( 'ifChanged', function () {

        reset_obr_groups(2);

        forma_ingresso = $('input[name=forma_ingresso]:checked').val();

        var active_tab = activeTab();

        switch(forma_ingresso) {
            // FAZER A PROVA DO VESTIBULAR
            case '1' :
                $('#group_enem').addClass('hide');
                $('#group_vestibular').removeClass();
                $('#group_local_prova').removeClass('hide');
                $('#group_outros').addClass('hide');

                if (checkVestibularContinuado()) {
                    $("#group_vestibular_continuado").removeClass('hide');
                }

                $("#btnSubmit").removeClass('disabled');
                break;

            // UTILIZAR NOTA DO ENEM
            case '2' :
                $('#group_enem').removeClass();
                $('#group_vestibular').removeClass();
                $('#group_local_prova').addClass('hide');
                $('#group_outros').addClass('hide');

                if (checkVestibularContinuado()) {
                    $("#group_vestibular_continuado").addClass('hide');
                }

                $("#btnSubmit").removeClass('disabled');
                break;

            // OUTROS DIPLOMADOS OU TRANSFERENCIA
            case '3' :
                $('#group_local_prova').addClass('hide');
                $('#group_enem').addClass('hide');
                $('#group_vestibular').addClass('hide');
                $('#group_outros').removeClass();

                if (checkVestibularContinuado()) {
                    $("#group_vestibular_continuado").addClass('hide');
                }

                if(active_tab == 'tab2') {
                    $("#btnSubmit").addClass('disabled');
                }
                break;
        }
    });

    montarCampoVestibularContinuadoDatas();
    montarCamposEscola();
    montarInputNotaEnem();

    // Quando estiver abrindo a pagina para CONSULTAR PAGAMENTO
    var activeTabAtual = activeTab();
    if (activeTabAtual == 'tabPagamento' || activeTabAtual == 'tabAprovados') {
        $("#email").removeAttr('pattern');
        $('#cpf').mask("999.999.999-99").attr('placeholder', "CPF");
    }

    $("#group_outros .btn-transferencia-diplomado").on('click', function() {
        var btn = $(this);
        var btnTipo = btn.attr('data-tipo');

        if (btnTipo) {
            ajaxStartLoading();

            // insere o candidato no contatoexterno do viper
            $.ajax({
                type: 'POST',
                url: '/inscricao/store-candidato-contato-externo',
                data: {
                    tipo: "Interesse",
                    segmento: "Graduação",
                    nomecompleto: $('#nome').val() + ' ' + $('#sobrenome').val(),
                    email: $('#email').val(),
                    telefone: $('#fone1').val(),
                    comochegou: 'vestibular',
                    assunto: btnTipo,
                    _token: $('input[name=_token]').val()
                }
            }).always(function() {
                $("#group_outros .group-buttons").addClass('hide');
                $("#group_outros .msg-success").removeClass('hide');
                ajaxStopLoading();
            });
        }
    });

    /* ----------------------------------------------------------------------
     * Evento de validação ao enviar o form de inscrição.
     * ----------------------------------------------------------------------
     */

    $('button[type=submit]').click(function (event) {

        /* Preenche os campos da etapa 4 com os dados informados na etapa 1 */
        var active_tab = activeTab();
        /* ----------------------------------------------------------------------
         * Valida Etapa 1
         * ----------------------------------------------------------------------
         */

        if(active_tab == 'tab1') {

            var nome = $('#nome');
            var sobrenome = $('#sobrenome');
            var fone1 = $('#fone1');
            var email = $('#email');

            nome.val($('#nome_contato').val());
            sobrenome.val($('#sobrenome_contato').val());
            fone1.val($('#fone_contato').val());
            email.val($('#email_contato').val());

            obr = [
                'nome_contato',
                'sobrenome_contato',
                'email_contato',
                'fone_contato'
            ];

            emailContato = $('#email_contato');
            validarEmailContato = validarEmail(emailContato.val());
            if (!validarEmailContato) {
                var objPai = emailContato.parent();
                if(objPai && !objPai.is('.has-error.email-invalid')) {
                    objPai.addClass('has-error email-invalid').append('<div class="help-block">E-mail inválido.</div>');
                }
            }

            var filiaisChecked = $(".check-filial-id:checked").val();

            var tabContent = blocoFormaEnsino.find('.tab-content');

            if (!filiaisChecked) {
                if (!tabContent.hasClass('has-error')) {
                    tabContent.addClass('has-error')
                    tabContent.append('<div class="help-block">Selecione a Unidade ou Polo em que deseja estudar.</div>');
                }
            } else {
                if (tabContent.hasClass('has-error')) {
                    tabContent.removeClass('has-error');
                    tabContent.find(".help-block").remove();
                }
            }

            if(verifyObr(obr) && validarEmailContato && filiaisChecked) {

                controll_tab++;

                tab_vestibular.find('input[name=vestibular_id]:checked').trigger('ifChanged');

                $('#tab-etapas li:eq(1) a').on('shown.bs.tab', function (e) {

                    //e.target: proximaAba
                    //e.relatedTarget: AbaAtual
                    var proximaAba = $(e.target);
                    if (proximaAba.attr('aria-controls') == "tab2") {

                        var paramVestibularId = getCandidatoParams('vestibular_id');
                        if (paramVestibularId) {
                            // Se recebeu um parametro ?vestibular_id=11,22,33 na URL (separados por virgula), seleciona
                            //  o primeiro vestibular da lista exibido na tela.
                            var listaVestibularIds = paramVestibularId.split(',');

                            if (listaVestibularIds.length > 0) {

                                $.each(listaVestibularIds, function(i, id) {

                                    var inputVestibular = divTabVestibular.find("input[name=vestibular_id][value=" + id + "]:visible");
                                    if (inputVestibular.length > 0) {

                                        inputVestibular.iCheck('check');
                                        return false;
                                    }
                                });
                            }
                        } else {
                            // Se nao receber um parametro vestibular_id na URL e houver somente um vestibular disponivel, marca ele.
                            if (divTabVestibular.find("input[name=vestibular_id]:visible").length == 1) {
                                divTabVestibular.find("input[name=vestibular_id]:visible").iCheck('check');
                            }
                        }
                    }

                });

                $('#tab-etapas li:eq(1) a').tab('show');
                $('div.form-buttons button[type=button]').removeClass('disabled');



                // TODO: QUIZ
                /*if (VESTIBULAR_QUIZ) {
                    // Marca o unico vestibular visivel, que tenha a classe .vestibular-quiz na tag <tr>
                    var inputVestibularQuiz = $("#divTabVestibular input[name=vestibular_id]");
                    if (inputVestibularQuiz.length == 1) {
                        inputVestibularQuiz.iCheck('check');
                    }
                    // Apos marcar o vestibular, no final do metodo que busca os cursos,
                    //   avancar para a proxima etapa
                }*/

                //libera_tab(active_tab);
                event.preventDefault();

                // insere o candidato na tabela ves_candidato_temp
                $.ajax({
                    type: 'POST',
                    url: '/inscricao/storeCandidatoTemp',
                    data: {
                        nome: $('#nome_contato').val(),
                        sobrenome: $('#sobrenome_contato').val(),
                        email: $('#email_contato').val(),
                        telefone: $('#fone_contato').val(),
                        filial_id: $('input[name=filial_id]:checked').val(),
                        _token: $('input[name=_token]').val()
                    },
                    success: function(data){
                    }
                });
            }
        }

        /* ----------------------------------------------------------------------
         * Valida Etapa 2
         * ----------------------------------------------------------------------
         */
        if(active_tab == 'tab2') {
            //if(forma_ingresso && vestibular_id && verifyObr(obr)) {

            if($('[name=forma_ingresso]:checked').val() == 3){
                $("#btnSubmit").addClass('disabled');
            }

            if (validarEtapa2()) {
                // Após selecionado o vestibular e filial carrega os cursos ofertados antes de avançar.
                if(!AJAX_CURSOS_CARREGADOS){
                    inscricaoAjaxCursos();
                }
                $('#tab-etapas li:eq(2) a').tab('show');
                controll_tab++;
                event.preventDefault();

                // TODO: QUIZ
                if (VESTIBULAR_QUIZ) {
                    var inputsCursos = $("#tab_cursos input[name=opcao1]");
                    if (inputsCursos.length == 1) {
                        // Se existir apenas UM CURSO para este vestibular de quiz, marca ele e direciona para a etapa 4
                        inputsCursos.iCheck('check');
                        setTimeout(function() {
                            $('button.btn.btn-default.pull-right').click();

                            var nomeCursoOpcao1 = $('#tab_cursos input[name=opcao1]:checked').parent().parent().parent().find('td:eq(4)').text();
                            if (nomeCursoOpcao1) {
                                var htmlNomeCurso = '<div class="alert alert-info" role="alert"> <strong>Inscrição no Curso: ' + nomeCursoOpcao1 + '</strong></div>';
                                $("#tab4").prepend(htmlNomeCurso);
                            }


                        }, 200);
                    }
                }
            }
        }

        /* ----------------------------------------------------------------------
         * Valida Etapa 3
         * ----------------------------------------------------------------------
         */
        if(active_tab == 'tab3') {

            if(validarEtapa3()) {
                $('#tab-etapas li:eq(3) a').tab('show');
                //libera_tab(active_tab);
                controll_tab++;
                event.preventDefault();

                // Alteracao para sempre manter oculto o bloco da escola.
                /*if (inputCheckListaCidades.val()) {
                    blockEscola.removeClass('hide');
                } else {
                    blockEscola.addClass('hide');
                }*/
                blockEscola.addClass('hide');

                /*
                // Validacao para ocultar ou exibir o bloco da Escola
                var checkPrivado = checkVestibularSelecionadoPrivado();
                if(checkPrivado) {
                    var blockEscola = $("#blockEscola").removeClass('hide');
                    blockEscola.find(".select2.select2-container").css({ width: '100%' });
                } else {
                    $("#blockEscola").addClass('hide');
                }*/
            }
        }

        /* ----------------------------------------------------------------------
         * Valida Etapa 4
         * ----------------------------------------------------------------------
         */
        if(active_tab == 'tab4') {

            //var checkPrivado = checkVestibularSelecionadoPrivado();
            var checkDataNascimento = false;
            var dataNascimentoPai = $(".input-group.date").parent();
            if (!$("#data_nascimento").val()) {
                if (!dataNascimentoPai.hasClass('has-error')) {
                    dataNascimentoPai.addClass('has-error').append('<div class="help-block">Campo obrigatório.</div>');
                }
            } else {
                if (dataNascimentoPai.hasClass('has-error')) {
                    dataNascimentoPai.removeClass('has-error').find('.help-block').remove();
                }
                checkDataNascimento = true;
            }

            var obr = [];

            // Verifica SE o pais eh == 1 (Brasil): adiciona cpf aos campos obrigatorios
            //  SE pais != 1: adiciona o documento_estrangeiro aos campos obrigatorios
            if ($("#pais").val() == 1) {
                obr = obr.concat(['cpf']);
            } else {
                obr = obr.concat(['documento_estrangeiro']);
            }

            obr = obr.concat([
                'nome',
                'sobrenome',
                'sexo',
                'data_nascimento',
                'email',
                'fone1',
                'pais'
            ]);

            // IF para validar se torna obrigatorio o preenchimento da escola quando for vestibular privado
            /*
            if(checkPrivado && checkDataNascimento){
                // SE for um vestibular PRIVADO NAO OBRIGA preenchimento de todos os campos
                obr = obr.concat([
                    'nome',
                    'sobrenome',
                    'sexo',
                    'data_nascimento',
                    'email',
                    'fone1',
                    'pais',

                    // Obriga a escola
                    'cidade_escola',
                    'escola'
                ]);
            } else {
                // SE for um vestibular NORMAL OBRIGA preenchimento de todos os campos
                obr = obr.concat([
                    'nome',
                    'sobrenome',
                    'sexo',
                    'data_nascimento',
                    'email',
                    'fone1',
                    'pais'
                ]);
            }
            */

            // Se foi marcado o check Atendimento Consultor
            if ($("#tab4 #atendimento_consultor_sim:checked").length > 0) {
                obr = obr.concat(['consultor_usuarioid']);
            }
            var validarConsultor = validarBlocoConsultor();

            // Trata inclusão dos dados
            if (verifyObr(obr) && validarConsultor && checkDataNascimento) {
                return true;
            }
            $('html, body').animate({ scrollTop: 0 }, 'fast');
            return false;
        }

        if (active_tab == 'tabPagamento' || active_tab == 'tabAprovados' || active_tab == 'tabAprovadosBolsas') {

            var cpf = $("#cpf").val();
            var email = $("#email").val();

            if (cpf || email) {
                return true;
            }
            return false;
        }

        if (active_tab == 'tabCandidatosAprovados'){
            var vestibular = $("#vestibular").val();

            if(vestibular){
                return true
            }
            return false;
        }

        return false;
    });

    // TODO: QUIZ regras
    if (VESTIBULAR_QUIZ) {

        // Preenche os campos com os parametros da URL:
        ajaxStartLoading();

        // Marca forma de ingresso ENEM
        $(".formas-ingresso input[name=forma_ingresso][value=2]").iCheck('check');
        // Marca o unico vestibular visivel na tabela de vestibulares, que deve ser o do QUIZ com a class 'vestibular-quiz' em sua tag <tr>
        $("#divTabVestibular .vestibular-quiz input").iCheck('check');

        var tab1 = $("#tab1");
        var nomeCompleto = getCandidatoParams('nomecompleto');
        var arrayNome = nomeCompleto.split(' ');
        var primeiroNome = '';
        var segundoNome = '';

        // monta o primero nome e sobrenome
        for (var i=0; i < arrayNome.length; i++) {
            if ((arrayNome[i].length > 0) && (primeiroNome.length == 0)) {
                primeiroNome = arrayNome[i];
            } else {
                if (segundoNome.length > 0) {
                    segundoNome  += ' ' + arrayNome[i];
                } else {
                    segundoNome  += '' + arrayNome[i];
                }
            }
        }
        tab1.find('#nome_contato').val(primeiroNome);
        tab1.find('#sobrenome_contato').val(segundoNome);
        tab1.find('#fone_contato').val(getCandidatoParams('foneprincipal'));
        tab1.find('input[name=filial_id][value=4]').iCheck('check');

        var tab2 = $("#tab2");
        tab2.find('#enem_inscricao').val(getCandidatoParams('inscricaoenem'));
        tab2.find('#enem_nota_objetiva').val(getCandidatoParams('notaobjetiva'));
        tab2.find('#enem_nota_redacao').val(getCandidatoParams('notaredacao'));

        var tab4 = $("#tab4");
        tab4.find('#cpf').val(getCandidatoParams('cpf'));
        tab4.find("#sexo").val(getCandidatoParams('sexo')).change();
        tab4.find("#data_nascimento").val(getCandidatoParams('data_nascimento'));

        $('button.btn.btn-default.pull-right').click();
    }

    /**
     * Verifica se o parametro ead=1 veio na URL, e exibe a ABA: EAD - Ensino a Distancia
     */
    if($.urlParam('ead') == '1') {
        $('a[aria-controls=ensino_ead]').click();
    }


    var urlParamNome = $.urlParam('nomecompleto');
    if (urlParamNome) {
        urlParamNome = urlParamNome.replace('+', ' ');
        var listaNome = urlParamNome.split(' ');
        var nome = '';
        var sobrenome = '';
        for(i=0; i < listaNome.length; i++) {
            if (listaNome[i] && !nome) {
                nome = listaNome[i];
            } else if (listaNome[i]) {
                if (sobrenome) {
                    sobrenome += ' ';
                }
                sobrenome += listaNome[i];
            }
        }

        if (nome) {
            $('#nome_contato').val(nome);
        }
        if (sobrenome) {
            $('#sobrenome_contato').val(sobrenome);
        }
    }

    /**
     * Verifica se o parametro filial_id=X veio na URL, X eh o ID da filial, e marca check na filial X recebida.
     */
    var paramFilialId = $.urlParam('filial_id');
    if(paramFilialId) {
        var inputFilialId = $("input[name=filial_id][value=" + paramFilialId + "]");
        if (inputFilialId.length > 0) {
            inputFilialId.iCheck('check');
        }
    }

    var forma_ingresso = getCandidatoParams('forma_ingresso');

    switch(forma_ingresso) {
        case '1' :

             $('input[name=forma_ingresso][value=1]').iCheck('check');
             break;
         case '2' :

             $('input[name=forma_ingresso][value=2]').iCheck('check');
             break;
         case '3' :

             $('input[name=forma_ingresso][value=3]').iCheck('check');
             break;
    }

    /*// TODO: preencher a primeira etapa:
    setTimeout(function(){
        preencherTestes();
    }, 2000);*/


});


/*
function preencherTestes() {

    //TODO: preencher etapa 1
    $("#nome_contato").val("Rober");
    $("#sobrenome_contato").val("Zanotto Guerra");
    $("#email_contato").val("roberzguerra@gmail.com");
    $("#fone_contato").val("(54) 996038609");
    $('.check-filial-id[value=1]').iCheck('check');

    // Clica no botão para avançar
    $(".btn.btn-default.pull-right").click();

    /*
    // marca o vestibular
    $("input[name=vestibular_id][value=2298]").iCheck('check');

    // Marcar local da prova
    setTimeout(function() {
        $("input[name=local_prova_id][value=2]").iCheck('check');
    }, 3000);
    ////////////////////////////////////////////////////////////////////

    setTimeout(function(){
        // Marca a data do vestibular continuado
        $("#vestibular_continuado_datas").val(1267).change();

        setTimeout(function(){
            // clica no botao avançar
            $(".btn.btn-default.pull-right").click();

            setTimeout(function() {
                // Escolhe as 2 opcoes do vestibular
                $("input[name=opcao1][value=14]").iCheck('check'); // Seleciona Administracao
                $("input[name=opcao2][value=16]").iCheck('check'); // Seleciona Bacharel em Design

                // Clica no botao avançar
                $(".btn.btn-default.pull-right").click();
            }, 500);
        }, 500);
    }, 5000);

}
*/


